import StatusesCountersSocket from '@/services/repositories/statuses-counters-repository';

export default {
  statusesCounters: new StatusesCountersSocket(),
};
